import mutations from './impactAssessmentDataHandling.mutations'
import actions from './impactAssessmentDataHandling.actions'
import getters from './impactAssessmentDataHandling.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
